var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLevelsProgressStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4020_78099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9572 38.1175C34.4828 38.1175 43.0155 29.5848 43.0155 19.0592C43.0155 8.53365 34.4828 0.000976562 23.9572 0.000976562C13.4316 0.000976562 4.89893 8.53365 4.89893 19.0592C4.89893 29.5848 13.4316 38.1175 23.9572 38.1175Z",
    fill: "#FFD15C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51793 30.2089L1.96045 41.5758L9.61399 41.1695L13.0912 48.001L19.1573 37.4845C14.8108 36.36 11.0786 33.7427 8.51793 30.2089Z",
    fill: "#40596B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4343 30.1522C36.8925 33.6955 33.1603 36.3222 28.8232 37.4655L34.9083 48.001L38.3854 41.1695L46.039 41.5758L39.4343 30.1522Z",
    fill: "#40596B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9572 32.8734C31.5866 32.8734 37.7714 26.6886 37.7714 19.0592C37.7714 11.4299 31.5866 5.24506 23.9572 5.24506C16.3279 5.24506 10.1431 11.4299 10.1431 19.0592C10.1431 26.6886 16.3279 32.8734 23.9572 32.8734Z",
    fill: "#F8B64C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4251 17.5663C33.8503 17.1506 33.6141 16.423 33.0283 16.338L27.5763 15.5443C27.3401 15.5065 27.1417 15.3648 27.0377 15.1474L24.5999 10.2057C24.3354 9.66711 23.57 9.66711 23.3055 10.2057L20.8771 15.1474C20.7732 15.3553 20.5653 15.5065 20.3385 15.5443L14.8866 16.338C14.3007 16.423 14.0645 17.1506 14.4897 17.5663L18.4299 21.412C18.5999 21.5821 18.6755 21.8183 18.6377 22.0451L17.7118 27.4687C17.6078 28.0545 18.2314 28.5081 18.7606 28.2246L23.6362 25.664C23.844 25.5506 24.0992 25.5506 24.307 25.664L29.1826 28.2246C29.7118 28.4986 30.3259 28.0545 30.2314 27.4687L29.296 22.0451C29.2582 21.8088 29.3338 21.5726 29.5039 21.412L33.4251 17.5663Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4020_78099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelsProgressStar);
export default __webpack_public_path__ + "static/media/levels-progress-star.b1f6c978443736a4716da53221751e3a.svg";
export { ForwardRef as ReactComponent };